// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeLhs__contentWrap__1DzN5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeLhs/ConsentTypeLhs.css
// module id = 1366
// module chunks = 0